import cookies from "../../../../utils/cookies";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";

export default function MallName({ className }) {
  const agentInfo = cookies.getAgentInfo();
  const navigateTo = useNavigateTo();
  
  return (
    <h1 className={`cursor-pointer ${className}`} onClick={() => navigateTo('/')}>
      {agentInfo.agentName}
    </h1>
  );
}
